module.exports = __webpack_public_path__ + "img/consultant_verify_idcard_front.3671eb28.png";